import ISite from "interfaces/models/ISiteHwrc";
import IClaimHwrc from "interfaces/responses/IClaimHwrc";

const mapClaimToSite = (claim : IClaimHwrc) : ISite => {
  const site : ISite = {
    siteId: claim.id,
    siteName: claim.displayName
  };

  return site;
};

export { mapClaimToSite };
